/**
 * Normalizacja etykiety kafelka / `name` z Dato (np. „Przestrzeń” === „przestrzeń”).
 */
function normalizeGalleryLabel(s) {
  return String(s ?? "")
    .trim()
    .toLocaleLowerCase("pl-PL");
}

/**
 * Pierwszy URL z każdej pozycji `allGalleries` indeksowany po `name`.
 * @param {Array<{ name?: string, gallery?: Array<{ url?: string }> }> | null | undefined} allGalleries
 * @returns {Map<string, string>}
 */
function firstImageUrlByGalleryName(allGalleries) {
  const map = new Map();
  if (!Array.isArray(allGalleries)) return map;
  for (const entry of allGalleries) {
    const key = normalizeGalleryLabel(entry?.name);
    const first = entry?.gallery?.[0]?.url;
    if (!key || typeof first !== "string" || !first.trim()) continue;
    map.set(key, first.trim());
  }
  return map;
}

/**
 * Podmienia `src` w szablonie bento:
 * 1) Jeśli jest `allGalleries` — pierwsze zdjęcie z rekordu, którego `name` pasuje do `cap` kafelka.
 * 2) W przeciwnym razie — kolejne URL z singletonu `gallery` (jak wcześniej).
 */
export function mergeLandingBento(staticItems, galleryRecord, allGalleries) {
  const byName = firstImageUrlByGalleryName(allGalleries);
  if (byName.size > 0) {
    return staticItems.map((item) => {
      const capKey = normalizeGalleryLabel(item.cap);
      const remote = capKey ? byName.get(capKey) : null;
      if (!remote) return item;
      return { ...item, src: remote, fromCms: true };
    });
  }

  if (!galleryRecord || typeof galleryRecord !== "object") {
    return staticItems;
  }

  let urls = (Array.isArray(galleryRecord.gallery) ? galleryRecord.gallery : [])
    .map((g) => g?.url)
    .filter((u) => typeof u === "string" && u.trim() !== "");

  if (urls.length === 0 && galleryRecord.preview?.url) {
    const p = String(galleryRecord.preview.url).trim();
    if (p) urls = [p];
  }

  return staticItems.map((item, i) => {
    const remote = urls[i];
    if (!remote) return item;
    return { ...item, src: remote, fromCms: true };
  });
}
